import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem('authToken');

  if (!token) return <Navigate to="/login" />;

  return children
};

export default ProtectedRoute;
